export const headers = {
  headers: {
    Authorization: process.env.REACT_APP_API,
  },
};
